import { render, staticRenderFns } from "./Cta_v1.vue?vue&type=template&id=2eb5c469&scoped=true&lang=pug"
import script from "./Cta_v1.vue?vue&type=script&lang=js"
export * from "./Cta_v1.vue?vue&type=script&lang=js"
import style0 from "./Cta_v1.vue?vue&type=style&index=0&id=2eb5c469&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2eb5c469",
  null
  
)

export default component.exports